import { useEffect } from 'react'

import { makeVar, useReactiveVar } from '@apollo/client'

const onlineVar = makeVar(true)

/**
 * online 상태 변경으로 리렌더링을 일으키고 싶을 때 씁니다.
 */
export const useIsOnline = () => useReactiveVar(onlineVar)

/**
 * 리렌더링 없이 현재 online 상태를 가져오고 싶을 때 씁니다.
 */
export const isOnline = () => onlineVar()

const useGlobalOnline = () => {
  useEffect(() => {
    const handleOffLine = () => onlineVar(false)
    const handleOnline = () => onlineVar(true)

    window.addEventListener('offline', handleOffLine)
    window.addEventListener('online', handleOnline)

    return () => {
      window.removeEventListener('offline', handleOffLine)
      window.removeEventListener('online', handleOnline)
    }
  }, [])
}

export default useGlobalOnline
